import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Care Preferences checklist screen
import { CarePreferencesChecklistScreen } from '../../screens/checklists/CarePreferencesChecklistScreen';

// LTC Preferences screens (existing)
import { LTCPreferencesDataScreen } from '../../screens/tasks/finalCare/ltcPreferences/LTCPreferencesDataScreen';
import { LTCPreferencesInputScreen } from '../../screens/tasks/finalCare/ltcPreferences/LTCPreferencesInputScreen';
import { LTCPreferencesIntroScreen } from '../../screens/tasks/finalCare/ltcPreferences/LTCPreferencesIntroScreen';
import { LTCPreferencesLockedScreen } from '../../screens/tasks/finalCare/ltcPreferences/LTCPreferencesLockedScreen';
import { LTCPreferencesLockUnlockScreen } from '../../screens/tasks/finalCare/ltcPreferences/LTCPreferencesLockUnlockScreen';
import { LTCPreferencesUnlockedScreen } from '../../screens/tasks/finalCare/ltcPreferences/LTCPreferencesUnlockedScreen';

// Pet Care Preferences screens (existing)
import { PetCarePreferencesDataScreen } from '../../screens/tasks/finalCare/petCare/PetCarePreferencesDataScreen';
import { PetCarePreferencesInputScreen } from '../../screens/tasks/finalCare/petCare/PetCarePreferencesInputScreen';
import { PetCarePreferencesIntroScreen } from '../../screens/tasks/finalCare/petCare/PetCarePreferencesIntroScreen';
import { PetCarePreferencesLockedScreen } from '../../screens/tasks/finalCare/petCare/PetCarePreferencesLockedScreen';
import { PetCarePreferencesLockUnlockScreen } from '../../screens/tasks/finalCare/petCare/PetCarePreferencesLockUnlockScreen';
import { PetCarePreferencesUnlockedScreen } from '../../screens/tasks/finalCare/petCare/PetCarePreferencesUnlockedScreen';

// End-of-Life Wishes screens
import { EndOfLifeWishesDataScreen } from '../../screens/tasks/carePreferences/endOfLifeWishes/EndOfLifeWishesDataScreen';
import { EndOfLifeWishesInputScreen } from '../../screens/tasks/carePreferences/endOfLifeWishes/EndOfLifeWishesInputScreen';
import { EndOfLifeWishesIntroScreen } from '../../screens/tasks/carePreferences/endOfLifeWishes/EndOfLifeWishesIntroScreen';
import { EndOfLifeWishesLockedScreen } from '../../screens/tasks/carePreferences/endOfLifeWishes/EndOfLifeWishesLockedScreen';
import { EndOfLifeWishesLockUnlockScreen } from '../../screens/tasks/carePreferences/endOfLifeWishes/EndOfLifeWishesLockUnlockScreen';
import { EndOfLifeWishesUnlockedScreen } from '../../screens/tasks/carePreferences/endOfLifeWishes/EndOfLifeWishesUnlockedScreen';

const Stack = createNativeStackNavigator();

const CarePreferencesStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="CarePreferencesChecklist" component={CarePreferencesChecklistScreen} />

      {/* LTC Preferences screens */}
      <Stack.Screen name="LTCPreferencesIntro" component={LTCPreferencesIntroScreen} />
      <Stack.Screen name="LTCPreferencesInput" component={LTCPreferencesInputScreen} />
      <Stack.Screen name="LTCPreferencesLockUnlock" component={LTCPreferencesLockUnlockScreen} />
      <Stack.Screen name="LTCPreferencesUnlocked" component={LTCPreferencesUnlockedScreen} />
      <Stack.Screen name="LTCPreferencesLocked" component={LTCPreferencesLockedScreen} />
      <Stack.Screen name="LTCPreferencesData" component={LTCPreferencesDataScreen} />

      {/* Pet Care Preferences screens */}
      <Stack.Screen name="PetCarePreferencesIntro" component={PetCarePreferencesIntroScreen} />
      <Stack.Screen name="PetCarePreferencesInput" component={PetCarePreferencesInputScreen} />
      <Stack.Screen name="PetCarePreferencesLockUnlock" component={PetCarePreferencesLockUnlockScreen} />
      <Stack.Screen name="PetCarePreferencesUnlocked" component={PetCarePreferencesUnlockedScreen} />
      <Stack.Screen name="PetCarePreferencesLocked" component={PetCarePreferencesLockedScreen} />
      <Stack.Screen name="PetCarePreferencesData" component={PetCarePreferencesDataScreen} />

      {/* End-of-Life Wishes screens */}
      <Stack.Screen name="EndOfLifeWishesIntro" component={EndOfLifeWishesIntroScreen} />
      <Stack.Screen name="EndOfLifeWishesInput" component={EndOfLifeWishesInputScreen} />
      <Stack.Screen name="EndOfLifeWishesLockUnlock" component={EndOfLifeWishesLockUnlockScreen} />
      <Stack.Screen name="EndOfLifeWishesUnlocked" component={EndOfLifeWishesUnlockedScreen} />
      <Stack.Screen name="EndOfLifeWishesLocked" component={EndOfLifeWishesLockedScreen} />
      <Stack.Screen name="EndOfLifeWishesData" component={EndOfLifeWishesDataScreen} />
    </Stack.Navigator>
  );
};

export default CarePreferencesStackNavigator;
